var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/compose/components/upload-form.tsx";
import classNames from 'clsx';
import React from 'react';
import { useCompose } from 'soapbox/hooks';
import Upload from './upload';
import UploadProgress from './upload-progress';

const UploadForm = _ref => {
  let {
    composeId
  } = _ref;
  const mediaIds = useCompose(composeId).media_attachments.map(item => item.id);
  const classes = classNames('compose-form__uploads-wrapper', {
    'contains-media': mediaIds.size !== 0
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "compose-form__upload-wrapper",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(UploadProgress, {
    composeId: composeId,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 7
    }
  }, mediaIds.map(id => /*#__PURE__*/React.createElement(Upload, {
    id: id,
    key: id,
    composeId: composeId,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 11
    }
  }))));
};

export default UploadForm;